export default [{
  text: '',
  items: [
    { icon: 'mdi-view-dashboard-outline', key: 'menu.dashboard', text: 'Dashboard', link: '/dashboard'  },
    { icon: 'mdi-book-open', key: 'menu.dashboard', text: 'Apply for permit', link: '/apply'  },
    { icon: 'mdi-format-list-bulleted', key: 'menu.dashboard', text: 'Permit History', link: '/permithistory'  }
  ]
}]
